import React from "react";
import { Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { injectModels } from "../../../redux/injectModels";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { AdminTradersService } from "../../../services";
import { formatDateENGB } from "../../../utils/common-methods";
import { Routes } from "../../../constants";

function TradersList(props) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await AdminTradersService.getAllTraders();
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleEdit = async (profile) => {
    navigate(Routes.ADMIN_EDIT_TRADER, { state: { profile: profile } });
  };

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };
  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              {" "}
              <i className="fa-solid fa-chevron-right"></i>Event Traders
            </li>
          </ol>
        </nav>
      </div>

      <div className="table-responsive">
        <div>
          <h2>Event Traders</h2>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Website</th>
              <th>Created On</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx} style={{ verticalAlign: "middle" }}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{item?.businessName}</td>
                      <td>{item?.email}</td>
                      <td>{item?.website}</td>
                      <td>{formatDateENGB(item?.createdOn)}</td>
                      <td
                        className="delete-create"
                        style={{ textAlign: "center" }}
                      >
                        {item?.isActive === true ? (
                          <i className="ri-check-fill"></i>
                        ) : (
                          <i className="ri-close-circle-line"></i>
                        )}
                      </td>
                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(item);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="ri-pencil-line"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <p className="mb-3">
          <strong>Total Count: {filteredData.length}</strong>
        </p>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(TradersList);
